export default {"src":"/_next/static/media/googleIcon.2ef00428.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};